// Module
var code = "<div class=\"noDataBlock\">\r\n    <div class=\"noDataBlockIMG\">\r\n        <svg>\r\n            <use xlink:href=\"assets/webdesktop/web-desktop-sprite.svg#{{.noDataImg}}\"></use>\r\n        </svg>\r\n    </div>\r\n    <div class=\"noDataBlockText\">{{.noDataText}}</div>\r\n</div>";
// Exports
export default code;